import React from 'react'
import { SidebarCTABox, SidebarCTABoxHeader, SidebarCTABoxLink } from './SidebarCTABox'

function UploadCustomersCTABox () {
  return (
    <SidebarCTABox>
      <SidebarCTABoxHeader>
        Procurated will help you get reviews from your SLED customers.
      </SidebarCTABoxHeader>
      <SidebarCTABoxLink
        href='https://ratings.procurated.com/getreviews'
        text='Learn More'
      />
    </SidebarCTABox>
  )
}

export default UploadCustomersCTABox
